<template>
  <Dialog @keydown.esc.native="handleCloseDialog()">
    <div class="flex flex-col w-full h-full">
      <div id="header">
        <div class="flex justify-between items-center pl-5 pr-4 pt-3.5">
          <div class="flex items-center space-x-5">
            <div v-if="draft && draft.is_follow_up === true" class="flex items-center space-x-2">
              <div class="flex items-center justify-center rounded-full h-5 w-5 bg-purple-light">
                <img src="/static/roundtable_icons/sequence_icon.svg" class="w-3 h-3 pl-0.5" />
              </div>
              <span class="font-manrope text-gray-800">Follow Up</span>
            </div>
            <div class="flex items-center space-x-2 font-manrope text-gray-800 cursor-default">
              <img :src="`/static/roundtable_icons/${type}_icon_color.svg`" class="w-4 h-4" />
              <span v-if="type !== ''">{{ type === 'written' ? 'Written RoundTable' : 'Verbal RoundTable' }}</span>
            </div>
            <pl-menu ref="courseMenu" v-if="draft && draft.is_follow_up === false" direction="left" :menuSize="8">
              <button v-if="draft && draft.is_follow_up === false" slot="menu_trigger" class="flex items-center space-x-2.5 font-manrope text-gray-800 font-bold">
                <div class="flex items-center space-x-2.5 hover:underline">
                  <img src="/static/roundtable_icons/courses_icon.svg" class=" w-3 -mt-0.5" />
                  <span>{{ courseSelection }}</span>
                </div>
                <i class="fa-solid fa-chevron-down text-xs text-gray-600 hover:text-gray-800"></i>
              </button>
              <ul class="flex flex-col space-y-1.5 rounded-lg mt-0.5 text-sm shadow-lg px-1 py-1 font-manrope max-h-96" menu-content>
                <div class="w-full h-9 px-0.5">
                  <input
                    @click.stop
                    placeholder="Search by your course..."
                    class="bg-gray-50 w-full border border-solid border-gray-200 focus:border-gray-100 focus:ring-2 ring-offset-1 ring-primary px-3 rounded h-full"
                  />
                </div>
                <div class="max-h-72 overflow-y-auto">
                  <li v-for="(c, index) in getCoursesInstructor" :key="index" @click.stop="handleSelectCourse(c)" class="flex justify-between items-center space-x-2 hover:bg-gray-100 px-3 py-2 cursor-pointer rounded-md">
                    <span>{{ c.title }}</span>
                    <i v-if="courses.some(course => course.id === c.id)" class="fa-solid fa-check text-gray-400"></i>
                  </li>
                </div>
              </ul>
            </pl-menu>
            <div v-if="draft && draft.is_follow_up === true" class="flex items-center space-x-2.5 font-manrope text-gray-800 cursor-default">
              <img src="/static/roundtable_icons/courses_icon.svg" class=" w-3 -mt-0.5" />
              <span>{{ courseSelection }}</span>
            </div>
            
          </div>
          <div class="flex items-center space-x-2">
            <div v-if="isSaving" class="flex items-center space-x-2">
              <div class="flex items-center justify-center">
                <img src="/static/roundtable_icons/cloud-upload.svg" class="w-4 h-4"/>
              </div>
              <span class="font-manrope text-xs text-gray-800">Saving Changes...</span>
            </div>
            <Tooltip
              :text="`You have ${getProfile.activity_passes} RoundTable ${getProfile.activity_passes === 1 ? 'credit' : 'credits'}`"
              styleTooltip="top-0 right-full -mt-1 mr-2 rounded-lg px-3 shadow-sm border border-solid border-gray-200"
              textColor="text-blueGray-800"
              backgroundColor="bg-white"
            >
              <div v-if="is_teacher && free_teacher_account" class="select-none flex items-center justify-center w-12 font-manrope text-gray-800 hover:bg-pink-100 cursor-pointer bg-pink-50 h-7 space-x-1.5 rounded-full">
                <i class="fas fa-rocket text-pinky"></i>
                <span>{{ getProfile.activity_passes }}</span>
              </div>
            </Tooltip>
            <button @click="handleCloseDialog()" class="w-7 h-7 focus:ring-2 focus:ring-offset-2 focus:ring-primary-dark rounded-full cursor-pointer bg-gray-50 hover:bg-gray-100 text-base flex items-center justify-center hover:text-gray-800 text-gray-700">
              <i class="fas fa-times"></i>
            </button>
          </div>
        </div>
        <div class="flex justify-between items-center space-x-5 px-5 relative w-full mb-2.5 mt-2.5">
          <div class="flex-grow">
            <input
              v-model="title"
              :disabled="isGenerating"
              placeholder="Enter a title..."
              class="w-full text-3xl font-manrope font-bold text-gray-800 border-none bg-white py-1 outline-none"
            />
          </div>
          <div class="flex items-center space-x-2">
            <button
              class="flex items-center space-x-3 hover:shadow-sm rounded-md border border-solid hover:bg-gray-50 border-gray-200 hover:border-primary px-4 py-1.5"
              :class="{ 'border-primary': isToAddToPortfolio === true }"
              @click="isToAddToPortfolio = !isToAddToPortfolio"
            >
              <span class="text-gray-800">Add Portfolio</span>
              <Checkbox :is_checked="isToAddToPortfolio" />
            </button>
            <button @click="handleCreateRoundTable()" :disabled="isGenerating || isCreating ? true : false" class="disabled:opacity-50 flex items-center space-x-2 bg-primary hover:bg-primary-dark rounded-md border border-solid border-primary text-white py-1.5 px-4">
              <div v-if="isCreating === true" class="loader -ml-0.5"></div>
              <span>{{ isCreating === true ? 'Creating RoundTable...' : 'Create RoundTable' }}</span>
            </button>
          </div>
        </div>
        <div class="flex items-center justify-between w-full bg-white :disabled:bg-white h-11 focus-within:border-pinky border-b  border-solid border-gray-200 pl-4 pr-5">
          <div class="flex items-center w-full font-manrope">
            <div class="w-14 h-14 -ml-3">
              <iframe src="https://lottie.host/embed/874b8bf3-ca7e-46f3-9c81-cf94974ad30b/Djg5qZsQK9.lottie" width="100%" height="100%"></iframe>
            </div>
            <input 
              ref="genieRevise" 
              @keyup.enter="handleRevisePrompt()" 
              v-model="revise.input" 
              placeholder="How can I help you make this discussion prompt better?" 
              class="w-full disabled:bg-white border-none"
            />
          </div>
          <div class="flex items-center space-x-5">
            <pl-menu direction="right" :menuSize="3">
              <button slot="menu_trigger" class="flex items-center space-x-2.5 font-manrope text-gray-800">
                <span>{{ revise.mode }}</span>
                <i class="fa-solid fa-chevron-down text-xs text-gray-600 hover:text-gray-800"></i>
              </button>
              <ul class="flex flex-col space-y-1.5 rounded-lg mt-0.5 text-sm shadow-sm px-1 pt-0.5 pb-1 font-manrope max-h-96" menu-content>
                <li class="flex items-center space-x-1 justify-between hover:bg-gray-100 px-2.5 py-1 cursor-pointer rounded-md">
                  <span>Prompt</span>
                  <i v-if="revise.mode === 'Prompt'" class="fa-solid fa-check text-gray-400"></i>
                </li>
                <li v-if="type === 'written'" class="flex justify-between space-x-1 text-gray-400 cursor-not-allowed items-center hover:bg-gray-100 px-2.5 py-1 rounded-md">
                  <span>Selection</span>
                  <i v-if="revise.mode === 'Selection'" class="fa-solid fa-check text-gray-400"></i>
                </li>
              </ul>
            </pl-menu>
            <button @click="handleRevisePrompt()" :disabled="revise.input === '' || revise.input.length < 4 ? true : false" class="text-white w-8 h-6 rounded-lg flex justify-center items-center disabled:opacity-50 bg-pinky hover:bg-pinky-dark cursor-pointer">
              <i class="fa-solid fa-arrow-right-long"></i>
            </button>
          </div>
        </div>
        <div v-if="isRevising === true || isGenerating === true" class='w-full'>
          <div class='h-0.5 w-full bg-pink-100 overflow-hidden'>
            <div class='progress w-full h-full bg-pink-500 left-right'></div>
          </div>
        </div>
      </div>
      <div id="editor" class="flex items-start flex-grow h-full w-full">
        <div v-if="isGenerating === false && options.length > 0" class="2xl:w-3/12 xl:w-4/12 lg:w-5/12 md:w-6/12 hidden md:block h-full py-3 border-r border-solid border-gray-200">
          <div v-if="genieOptions.length" class="flex flex-col space-y-4 px-3 mb-3">
            <ul class="flex flex-col space-y-2 select-none">
              <li v-for="(op, index) in genieOptions" :key="index" @click="handleChangeOption(op, 'genie')" class="cursor-pointer flex flex-col space-y-2 w-full border border-solid border-gray-200 rounded-md px-4 py-3">
                <div class="flex justify-between items-center">
                  <h6 class="text-xs font-manrope text-gray-600">Draft Template {{ index + 1 }}</h6>
                  <Checkbox :is_checked="selected && selected.id === op.id"/>
                </div>
                <h3 class="font-manrope text-gray-800 font-bold">{{ op.title }}</h3>
              </li>
            </ul>
          </div>
          <div v-if="universeOptions.length" class="flex flex-col space-y-2.5 px-3">
            <div class="flex justify-between items-center">
              <div class="flex items-center space-x-2.5">
                <img src="/static/roundtable_options_create/browse_universe.svg" class="w-6 h-6 rounded-full"/>
                <h5 class="font-manrope text-gray-800 font-bold">From Parlay Universe</h5>
              </div>
              <button @click="handleGoToUniverse()" class="w-7 h-7 hover:bg-gray-100 rounded-full hover:text-pinky text-gray-800 text-xs">
                <i class="fa-solid fa-arrow-up-right-from-square"></i>
              </button>
            </div>
            <ul class="flex flex-col space-y-2 select-none">
              <li v-for="(op, index) in universeOptions"  @click="handleChangeOption(op, 'community')" class="flex flex-col border border-solid px-4 py-3 rounded-md hover:border-primary" :class="{'border-primary': selected.id === op.id, 'border-gray-200': selected.id !== op.id }">
                <div class="flex items-center justify-between">
                  <span class="font-manrope text-gray-600 text-xs mb-1">Option {{ index + 1 }}</span>
                  <Checkbox :is_checked="selected && selected.id === op.id"/>
                </div>
                <h6 class="hover:underline cursor-pointer font-manrope font-bold mb-2">{{ op.title }}</h6>
                <div class="flex items-center space-x-2">
                  <img :src="op.avatar_url" class="w-5 h-5 rounded-full"/>
                  <span class="font-light font-poppins text-gray-600 text-xs">{{ op.name }}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="w-full h-full">
          <div v-if="type === 'written' && draft" class="w-full h-full">
            <Editor
              api-key="no-api-key"
              :init="editor"
              v-model="written.prompt"
              ref="editorWrittenPrompt"
            />
          </div>
          <div v-if="type === 'verbal' && draft" class="h-full">
            <div id="toolbar-container" class="border-b border-solid border-gray-200"></div>
            <div class="pb-60 overflow-y-auto h-full">
              <div class="relative">
                <Editor
                  api-key="no-api-key"
                  :init="editorVerbal"
                  v-model="verbal.instructions"
                  ref="editorVerbalPrompt"
                />
              </div>
              <div class="px-16">
                <div class="flex flex-col space-y-5 font-manrope mb-8">
                  <h3 class="text-2xl text-gray-800 font-bold">
                    Content & Multimedia
                  </h3>
                  <div v-if="isGenerating === false" class="flex items-center space-x-2 w-full">
                    <input 
                      class="w-full bg-gray-100 border border-solid rounded-md border-gray-200 py-1.5 px-3.5 focus-within:ring-2 ring-offset-2 ring-primary" 
                      v-model="resource.resourceName" 
                      placeholder="Enter a Resource Name..."
                    />
                    <input 
                      class="w-full bg-gray-100 border border-solid rounded-md border-gray-200 py-1.5 px-3.5 focus-within:ring-2 ring-offset-2 ring-primary" 
                      v-model="resource.resourceURL"
                      @keyup.enter="handleAddResource()" 
                      placeholder="Enter a Resource URL..."
                    />
                    <button @click="handleAddResource()" :disabled="resource.resourceName === '' && resource.resourceURL === '' ? true : false" class="disabled:opacity-50 bg-blueGray-800 rounded-md px-4 py-1.5 text-white">Add</button>
                  </div>
                  <div v-if="verbal.resources.length > 0 && isGenerating === false" class="w-full">
                    <ul class="flex flex-col">
                      <Draggable
                        v-model="verbal.resources"
                        @start="isDragResource = true"
                        @end="isDragResource = false"
                        handle=".handle"
                        class="h-full flex-grow overflow-y-auto"
                      >
                        <li v-for="(r, index) in verbal.resources" :key="index" class="flex items-center justify-between space-x-2 text-base mb-1 text-blue-600">
                          <div class="flex items-center space-x-2">
                            <button class="h-8 w-8 hover:bg-gray-100 rounded-full handle">
                              <i class="fa-solid fa-grip-vertical text-blueGray-600"></i>
                            </button>
                            <a :href="r.resourceURL" target="_blank" class="hover:underline">{{ r.resourceName }}</a>
                            <i class="fa-solid fa-arrow-up-right-from-square text-blue-500" style="font-size:11px"></i>
                          </div>
                          <div class="flex items-center space-x-2">
                            <div 
                              @click="handleChangeResourceStatus(r.id)"
                              title="Hide Resource" 
                              class="w-8 cursor-pointer h-5 flex items-center bg-gray-200 rounded-full p-1 duration-300 ease-in-out"
                              :class="{ 'bg-primary': r.is_active }"
                            >
                              <div 
                                class="bg-white w-3 h-3 rounded-full transform duration-300 ease-in-out"
                                :class="{ 'translate-x-3': r.is_active }"
                                >
                              </div>
                            </div>
                            <button @click="handleDeleteResource(r.id)" title="Remove" class="flex items-center justify-center w-7 h-7 bg-gray-100 hover:bg-red-100 rounded-full text-red-500">
                              <i class="fa-solid fa-square-minus text-xs"></i>
                            </button>
                          </div>
                        </li>
                      </Draggable>
                    </ul>
                  </div>
                  <div v-if="isGenerating === true">
                    <div class="flex flex-col space-y-2.5 w-full animate-pulse">
                      <div class="h-3.5 bg-gray-200 rounded-full dark:bg-gray-700 w-6/12"></div>
                      <div class="h-3.5 bg-gray-300 rounded-full dark:bg-gray-700 w-8/12"></div>
                      <div class="h-3.5 bg-gray-200 rounded-full dark:bg-gray-700 w-5/12"></div>
                    </div>
                  </div>
                </div>
                <!-- Questions -->
                <div class="flex flex-col space-y-5 font-manrope">
                  <div class="flex items-center justify-between">
                    <h3 class="text-2xl text-gray-800 font-bold">
                      Questions
                    </h3>
                  </div>
                  <div v-if="isGenerating === false" class="flex items-center space-x-2 w-full">
                    <input 
                      class="w-full bg-gray-100 border border-solid rounded-md border-gray-200 py-1.5 px-3.5 focus-within:ring-2 ring-offset-2 ring-primary" 
                      v-model="question.question" 
                      placeholder="Enter a Question..."
                      @keyup.enter="handleAddQuestion()"
                    />
                    <button @click="handleAddQuestion()" :disabled="question.question === '' ? true : false" class="bg-blueGray-800 disabled:opacity-50 rounded-md px-4 py-1.5 text-white">Add</button>
                  </div>
                  <div v-if="verbal.questions.length > 0 && isGenerating === false" class="w-full">
                    <ul class="flex flex-col">
                      <Draggable
                        v-model="verbal.questions"
                        @start="isDragQuestion = true"
                        @end="isDragQuestion = false"
                        handle=".handle-question"
                        class="h-full flex-grow overflow-y-auto"
                      >
                        <li v-for="(q, index) in verbal.questions" class="flex justify-between items-center space-x-2 text-base mb-1.5">
                          <div class="flex items-center space-x-2 w-full">
                            <button class="h-8 w-8 hover:bg-gray-100 focus-within:outline-none rounded-full handle-question cursor-move">
                              <i class="fa-solid fa-grip-vertical text-blueGray-600"></i>
                            </button>
                            <input @select="handleTextSelection($event, q)" v-model="q.question" class="w-full border-none rounded"></input>
                          </div>
                          <div class="flex items-center space-x-3">
                            <div 
                              @click="handleChangeQuestionStatus(q.id)"
                              title="Hide Resource" 
                              class="w-8 cursor-pointer h-5 flex items-center bg-gray-200 rounded-full p-1 duration-300 ease-in-out"
                              :class="{ 'bg-primary': q.is_active }"
                            >
                              <div 
                                class="bg-white w-3 h-3 rounded-full transform duration-300 ease-in-out"
                                :class="{ 'translate-x-3': q.is_active }"
                                >
                              </div>
                            </div>
                            <button @click="handleDeleteQuestion(q.id)" title="Remove" class="flex items-center justify-center w-7 h-7 bg-gray-100 hover:bg-red-100 focus-within:border-red-500 focus-within:border focus-within:border-solid focus-within:outline-none rounded-full text-red-500">
                              <i class="fa-solid fa-square-minus text-xs"></i>
                            </button>
                          </div>
                        </li>
                      </Draggable>
                    </ul>
                  </div>
                  <div v-if="isGenerating === true">
                    <div class="flex flex-col space-y-2.5 w-full animate-pulse">
                      <div class="h-3.5 bg-gray-200 rounded-full dark:bg-gray-700 w-6/12"></div>
                      <div class="h-3.5 bg-gray-300 rounded-full dark:bg-gray-700 w-10/12"></div>
                      <div class="h-3.5 bg-gray-200 rounded-full dark:bg-gray-700 w-6/12"></div>
                      <div class="h-3.5 bg-gray-300 rounded-full dark:bg-gray-700 w-5/12"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
  </Dialog>
</template>
<script>
  import Axios from 'axios';
  import { mapGetters } from 'vuex';
  import { EventBus } from '../../utils/event-bus';
  import { EditorOptions } from './EditorOptions';
  import { EditorVerbalOptions } from './EditorVerbalOptions.js';
  import { GeneratingTemplate, GeneratingTemplateVerbal } from '../dashboard/NewRoundTable/Templates/Generating';

  // Components
  import Dialog from '../../components/Dialogs/Dialog.vue';
  import Editor from '@tinymce/tinymce-vue';
  import Checkbox from '../../components/modals/New_RoundTable/Components/Checkbox.vue';
  import { debounce } from 'lodash';
  import Draggable from 'vuedraggable';

  import RoundtableService from 'features/onlineRoundtables/onlineRoundtables.services';
  import LiveDiscussionService from 'services/liveDiscussion';
  import CourseService from 'services/courses';
  import { DefaultWrittenSettings } from '../../components/modals/New_RoundTable/Utils/Objects/DefaultWrittenSettings';
  import { filter } from 'lodash';
  import { uniqBy } from 'lodash';
  import { DefaultVerbalSettings } from '../../components/modals/New_RoundTable/Utils/Objects/DefaultVerbalSettings';
  import { ParlayWrittenTemplate } from '../dashboard/NewRoundTable/Templates/WrittenTemplate';
  import Tooltip from '../../components/Tooltip.vue';
  import URLconfigs from 'services/apiConfigs';
  /* Services ------------------------------------------------------------------------ */
  import authenticationServices from 'features/authentication/authentication.services';

  export default {
    name: "DraftIndex",
    components: {
      Editor,
      Dialog,
      Checkbox,
      Draggable,
      Tooltip,
    },
    props: {
      id: {
        type: String,
        required: true,
      },
      type: {
        type: String,
        required: true,
        default: null
      },
      isFollowUp: {
        type: Boolean,
        required: false,
        default: false,
      },
      gradeLevel: {
        type: String,
        required: false,
        default: null,
      },
      current: {
        type: Object,
        required: false,
        default: null,
      }
    },
    data() {
      return {
        title: "",
        initialActivityPasses: null,
        courses: [],
        written: {
          prompt: "",
          selection: "",
        },
        verbal: {
          instructions: "",
          questions: [],
          resources: [],
          selection: null
        },
        revise: {
          input: "",
          mode: "Prompt",
        },
        options: [],
        isSaving: false,
        isToAddToPortfolio: true,
        isGenerating: false,
        isRevising: false,
        isCreating: false,
        editor: EditorOptions,
        editorVerbal: EditorVerbalOptions,
        draft: null,
        input: "",
        resource: { resourceName: "", resourceURL: "", is_active: null, },
        question: { question: "", is_custom: null, is_active: null},
        followUpFromId: null,
        followUpFromRoundtable: null
      };
    },
    watch: {
      title: {
        handler: debounce(function () {
          if (this.isGenerating === false) {
            this.handleUpdateDraft();
          }
        }, 3500), 
        immediate: false
      },
      'written.currentPrompt': {
        handler: debounce(function () {
          if (this.isGenerating === false) {
            this.handleUpdateDraft();
          }
        }, 3500), 
        immediate: false
      },
      'verbal.instructions': {
        handler: debounce(function () {
          if (this.isGenerating === false) {
            this.handleUpdateDraft();
          }
        }, 3500), 
        immediate: false
      },
      'verbal.questions': {
        handler: debounce(function () {
          if (this.isGenerating === false) {
            this.handleUpdateDraft();
          }
        }, 3500), 
        immediate: false
      },
      'verbal.resources': {
        handler: debounce(function () {
          if (this.isGenerating === false) {
            this.handleUpdateDraft();
          }
        }, 3500), 
        immediate: false
      },
    },
    computed: {
      ...mapGetters(['getCourses', 'getProfile', 'getCourseDetail', 'getCurrentDiscussion', 'getCoursesInstructor']),
      courseSelection() {
        if (this.courses.length === 0) {
          return 'Select Course(s)';
        } else if (this.courses.length === 1) {
          return this.courses[0].title;
        } else {
          return `(${this.courses.length}) courses selected`;
        }
      },
      genieOptions() {
        const genieOptions = this.options.filter((o) => o.type === 'genie');
        return genieOptions;
      },
      universeOptions() {
        const universeOptions = this.options.filter((o) => o.type !== 'genie');
        return universeOptions;
      },
      isFreeAccount() {
        const profile = this.getProfile;
        return profile.activity_passes === 0 && !profile.is_paid && profile.school.school_id !== null && profile.school.school_id !== '';
      },
      free_accounts_validation() {
        return (
          this.getProfile.activity_passes === 0 &&
          this.getProfile.is_paid === false &&
          (this.getProfile.school.school_id !== null ||
            this.getProfile.school.school_id !== '')
        );
      },
      is_teacher() {
        return this.getProfile.role === 'teacher';
      },
      free_teacher_account() {
        return !this.getProfile.is_paid;
      },
    },
    methods: {
      getWordsCountEditor() {
        const refKey = `editor${this.draft.type.charAt(0).toUpperCase() + this.draft.type.slice(1)}Prompt`;
        const editor = this.$refs[refKey].editor;
        return editor.plugins.wordcount.getCount() ? editor.plugins.wordcount.getCount() : 0;
      },
      handleGoToUniverse: function() {
        const universe_url = `${URLconfigs.universeURL}/roundtables/browse?keyword=${this.input}`;
        authenticationServices.navigateToExternalWithAuth(universe_url);
      },
      handleGetDraft: async function() {
        try {
          const draft = await Axios.get(`/api/drafts/${this.id}`);
          return draft;
        } catch (error) {
          console.error(error);
          this.handleCloseDialog();
        }
      },
      handleCloseDialog: async function() {
        try {
          if (this.title === "") {
            await this.$store.dispatch('deleteDraft', {id: this.id});
          } else {
            await this.handleUpdateDraft();
          }
          await this.$store.dispatch('getRecentRoundtables');
          this.$router.replace({ query: {} });
          this.$emit('close');
          this.$emit('resetIsToStartFollowUp');
        } catch (error) {
          console.error("Error", error);
        }
      },
      handleSelectCourse: async function(course) {
        if (this.getProfile.is_paid === false) {
          const maxByCredits = this.initialActivityPasses;

          const maxCourses = Math.min(3, 1 + maxByCredits);

          const index = this.courses.findIndex(c => c.id === course.id);
          if (index !== -1) {
            this.courses.splice(index, 1);
            if (this.courses.length >= 1) {
              await this.$store.dispatch('addActivityPasses', 1);
            }
            return;
          } 

          if (this.courses.length >= maxCourses) {
            EventBus.$emit('createToast', { type: 'Info', message: "You can only select up to 3 courses. You can duplicate more after creating", time: 5000 });
            return;
          }

          this.courses.push(course);
          if (this.courses.length > 1) {
            await this.$store.dispatch('useActivityPass');
          }
        } else {
          const index = this.courses.findIndex(c => c.id === course.id);
          if (index !== -1) {
            this.courses.splice(index, 1);
          } else {
            if (this.courses.length >= 3) {
              EventBus.$emit('createToast', { type: 'Info', message: "It was not possible select more than 3 courses", time: 5000 });
              return;
            }
            this.courses.push(course);
          }
        }        
      },
      handleChangeInstructions: function(event) {
        this.verbal.instructions = event.target.innerText;
      },
      handleAddResource: function() {
        if (this.resource.name === '' || this.resource.url === '') {
          EventBus.$emit('createToast', {type: "Error", message: "You need to set name and a valid url to add a resource", time: 5000});
          return;
        }

        this.verbal.resources.push({ id: this.verbal.resources.length, resourceName: this.resource.resourceName, resourceURL: this.resource.resourceURL, is_active: true });
        this.handleUpdateDraft();
        this.resource = { resourceName: "", resourceURL: "", is_active: null };
      },
      handleDeleteResource: function(id) {
        const indexToDelete = this.verbal.resources.findIndex(item => item.id === id);
        if (indexToDelete !== -1) {
          this.verbal.resources.splice(indexToDelete, 1);
        }
      },
      handleChangeResourceStatus: function(id) {
        const resource_object = this.verbal.resources.find((obj, index) => index === id);
        this.verbal.resources.find((obj, index) => index === id).is_active = !resource_object.is_active;
      },
      handleAddQuestion: function() {
        if (this.question.question === '') {
          return;
        }
        this.verbal.questions.push({id: this.verbal.questions.length, question: this.question.question, is_active: true, is_custom: true });
        this.question = { question: "", is_active: null, is_custom: null };
      },
      handleDeleteQuestion: function(id) {
        const indexToDelete = this.verbal.questions.findIndex(item => item.id === id);
        if (indexToDelete !== -1) {
          this.verbal.questions.splice(indexToDelete, 1);
        }
      },
      handleChangeQuestionStatus: function(id) {
        const item = this.verbal.questions.find(q => q.id === id);
        if (!item) return; 
        if (typeof item.is_active === 'undefined') {
          item.is_active = true;
        } else {
          item.is_active = !item.is_active;
        }
      },
      handleChangeOption: function(option, optionType) {
        if (this.type === 'written') {
          this.handleUpdateWrittenOption(option, optionType);
        } 
        if (this.type === 'verbal') {
          this.handleUpdateVerbalOption(option, optionType);
        }
      },
      handleUpdateWrittenOption: function(option, optionType) {
        const editor = this.$refs.editorWrittenPrompt.editor;
        if (editor) {
          editor.undoManager.clear();
        }

        const currentOption = this.options.find(o => o.id === this.selected.id);
        if (currentOption) {
          currentOption.prompt = this.written.prompt;
        }
        if (option.prompt) {
          this.written.prompt = option.prompt;
        } 
        if (option.title) {
          this.title = option.title;
        } 
        this.selected = { id: option.id, title: option.title, prompt: option.prompt, type: optionType };
      },
      handleUpdateVerbalOption: function(option, optionType) {
        const currentOption = this.options.find(o => o.id === this.selected.id);

        if (currentOption) {
          currentOption.instructions = this.verbal.instructions;
          currentOption.questions = this.verbal.questions;
          currentOption.resources = this.verbal.resources;
        }

        Object.assign(this.verbal, {
          instructions: option.instructions || '',
          questions: option.questions || [],
          resources: option.resources || []
        });

        this.selected = { 
          id: option.id, title: option.title, instructions: this.verbal.instructions, questions: this.verbal.questions, resources: this.verbal.resources, type: optionType 
        };
      },
      handleUpdateDraft: async function() {
        if (this.isCreating === true || this.isRevising === true || this.isGenerating === true) {
          return;
        }
        try {
          this.isSaving = true;
          const payload = { 
            title: this.title, 
            courses: this.courses, 
            prompt: this.written.prompt,
            author_id: this.getProfile.id, 
            instructions: this.verbal.instructions,
            toggleable_guiding_questions: this.verbal.questions,
            toggleable_resource_questions: this.verbal.resources 
          };
          console.log(this.verbal.instructions);
          await Axios.put(`/api/drafts/${this.id}`, payload);
          this.isSaving = false;
        } catch (error) {
          console.error(error);
          EventBus.$emit('createToast', { type: 'Error', message: "Something went wrong while updating the draft. Please confirm that it still exists...", time: 5000 });
          await this.$store.dispatch('getRecentRoundtables');
          this.$emit('close');
        }
      },
      handleGenerateWrittenPrompt: async function() {
        if (this.input === '' || this.type !== 'written') return;

        try {
          this.isGenerating = true;
          this.written.prompt = GeneratingTemplate;

          const messages = [
            "Creating a lesson plan for your class discussion, this should take about 15 seconds!",
            "Sifting through the internet so you don't have to…",
            "Tailoring the discussion prompt to the grade level…",
            "Finding the perfect balance of challenge and curiosity…",
            "Defining learning goals…",
            "Designing higher order questions to spark curiosity and critical thinking…",
            "Generating peer feedback questions..."
          ];
          
          this.intervalID = setInterval(() => {
            const randomIndex = Math.floor(Math.random() * messages.length);
            const newTemplate = GeneratingTemplate.replace(
              /<span style="font-size: 16px" class="message">.*?<\/span>/,
              `<span style="font-size: 16px" class="message">${messages[randomIndex]}</span>`
            );
            this.written.prompt = newTemplate;
          }, 2500);
          
          const fileId = this.draft.file;
          const payload = { type: this.type, input: this.input, grade_level: this.gradeLevel, file: fileId };
          const response = await Axios.post(`/api/genie/v1/generate_prompt`, payload);
          if (!response) {
            throw new Error('Something failed generating a new prompt with Genie');
          }

          const premades = await Axios.post(`/api/genie/v1/prompt/community`, { input: this.input, type: this.type, file: fileId });
          premades.data.premades.map((p) => {
            this.options.push({ id: p.id, title: p.title, prompt: p.prompt, type: p.type, avatar_url: p.avatar_url });
          });

          clearInterval(this.intervalID);

          this.written.prompt = response.data.prompt;
          this.selected = { id: Math.random().toString(36).substring(2, 9), prompt: this.written.prompt };
          this.options.unshift({ id: this.selected.id, title: response.data.title, prompt: response.data.prompt, type: 'genie'});
          this.title = response.data.title;
          this.$refs.genieRevise.focus();

          const editor = this.$refs.editorWrittenPrompt.editor;
          if (editor) {
            editor.undoManager.clear();
            editor.options.set('disabled', false);
          }
          
          this.isGenerating = false;
        } catch (error) {
          console.error(error.response.data.message);
          if (this.intervalID) {
            clearInterval(this.intervalID);
          }
          if (this.isGenerating === true) {
            EventBus.$emit('createToast', { type: 'Error', message: error.response.data.message, time: 5000 });
          }
          this.isGenerating = false;
          this.written.prompt = ParlayWrittenTemplate;
          this.title = "";
          this.options = [];
        }
      },
      handleGenerateVerbalPrompt: async function() {
        if (this.input === '' || this.type !== 'verbal') return;
        try {
          
          this.isGenerating = true;

          this.verbal.instructions = GeneratingTemplateVerbal;

          const messages = [
            "Creating a lesson plan for your class discussion, this should take about 15 seconds!",
            "Sifting through the internet so you don't have to…",
            "Tailoring the discussion prompt to the grade level…",
            "Finding the perfect balance of challenge and curiosity…",
            "Defining learning goals…",
            "Designing higher order questions to spark curiosity and critical thinking…",
            "Generating peer feedback questions..."
          ];
          
          this.intervalID = setInterval(() => {
            const randomIndex = Math.floor(Math.random() * messages.length);
            const newTemplate = GeneratingTemplateVerbal.replace(
              /<span style="font-size: 16px" class="message">.*?<\/span>/,
              `<span style="font-size: 16px" class="message">${messages[randomIndex]}</span>`
            );
            this.verbal.instructions = newTemplate;
          }, 2500);

          const fileId = this.draft.file;
          const payload = { type: this.type, input: this.input, grade_level: this.gradeLevel, file: fileId };
          const response = await Axios.post(`/api/genie/v1/generate_prompt`, payload);

          const premades = await Axios.post(`/api/genie/v1/prompt/community`, { input: this.input, type: this.type, file: fileId });
          premades.data.premades.map((p) => {
            this.options.push({ id: p.id, title: p.title, prompt: p.prompt, type: p.type, avatar_url: p.avatar_url });
          });

          clearInterval(this.intervalID);
          
          this.title = response.data.title || "";
            
          this.verbal.instructions = response.data.instructions || "";
          this.verbal.questions = response.data.questions || [];
          this.verbal.resources = response.data.resources || [];
          this.selected = { 
            id: Math.random().toString(36).substring(2, 9), 
            instructions: this.verbal.instructions, 
            questions: this.verbal.questions, 
            resources: this.verbal.resources 
          };
          this.options.unshift({ 
            id: this.selected.id, 
            title: response.data.title, 
            instructions: this.verbal.instructions, 
            questions: this.verbal.questions, 
            resources: this.verbal.resources, 
            type: 'genie'
          });
          this.isGenerating = false;
        } catch (error) {
          console.error(error.response.data.message);
          if (this.isGenerating === true) {
            EventBus.$emit('createToast', { type: 'Error', message: error.response.data.message, time: 5000 });
          }
          this.isGenerating = false;
          this.verbal.instructions = "";
          this.verbal.questions = [];
          this.verbal.resources = [];
          this.options = [];
        }
      },
      handleGenerateOption: async function() {
        try {
          const fileId = this.draft.file;
          const payload = { input: this.input, grade_level: null, type: this.type, file: fileId };
          const response = await Axios.post(`/api/genie/v1/prompt/suggestions`, payload);

          if (!response.data) {
            throw new Error;
          }

          const option = {
            id: Math.random().toString(36).substring(2, 9),
            title: response.data.title,
            type: 'genie',
            ...(this.type === 'written' && { prompt: response.data.prompt || "" }),
            ...(this.type === 'verbal' && {
              instructions: response.data.instructions || "",
              questions: response.data.questions || [],
              resources: response.data.resources || []
            })
          };
          this.options.push(option);
        } catch (error) {
          this.isGenerating = false;
          this.verbal.instructions = "";
          this.verbal.questions = [];
          this.verbal.resources = [];
          this.options = [];
          if (this.isGenerating === true) {
            EventBus.$emit('createToast', { type: 'Error', message: error.response.data.message, time: 5000 });
          }
          
        }
      },
      handleRevisePrompt: async function() {
        if (this.type === 'written') {
          this.handleReviseWrittenPrompt();
          return;
        }

        if (this.type === 'verbal') {
          this.handleReviseVerbalPrompt();
          return;
        }
      },
      handleReviseWrittenPrompt: async function() {
        try {
          if (this.isRevising === true) {
            return;
          }
          this.isRevising = true;
          const payload = {
            input: this.revise.input,
            prompt: this.written.prompt,
            mode: this.revise.mode,
            selection: this.written.selection
          };          
          this.revise.input = 'Thinking...';
          this.$refs.genieRevise.blur();
          const response = await Axios.post(`/api/genie/v1/revise/written/prompt`, payload);
          const editor = this.$refs.editorWrittenPrompt.editor;
          if (editor) {
            editor.execCommand('SelectAll');
            editor.execCommand('mceInsertContent', false, response.data.revise);
          }
          this.written.prompt = response.data.revise;
          this.isRevising = false;
          this.revise.input = '';
        } catch (error) {
          console.error(error);
        }
      },
      handleReviseVerbalPrompt: async function() {
        try {
          if (this.isRevising === true) {
            return;
          }
          this.isRevising = true;
          const payload = {
            input: this.revise.input,
            instructions: this.verbal.instructions,
            questions: this.verbal.questions,
          };
          this.revise.input = 'Thinking...';
          this.$refs.genieRevise.blur();
          const response = await Axios.post(`/api/genie/v1/revise/verbal/prompt`, payload);
          this.verbal.questions = response.data.questions;
          this.verbal.instructions = response.data.instructions;
          
          this.isRevising = false;
          this.revise.input = '';
          this.revise.mode = 'Prompt';

        } catch (error) {
          console.error(error);
        }
      },
      handleCreateRoundTable: async function() {
        const MAX_WORDS_WRITTEN = 3000;
        const MAX_WORDS_VERBAL = 1000;

        const words = this.getWordsCountEditor();
        const message = `The prompt exceeds the maximum of ${this.draft.type === 'written' ? MAX_WORDS_WRITTEN : MAX_WORDS_VERBAL} words. Please revise it!`;
        const toast = { type: 'Error', message: message, time: 5000 };

        if (this.draft.type === 'written') {
          if (words > MAX_WORDS_WRITTEN) {
            return EventBus.$emit('createToast', toast);
          }
          await this.handleCreateWrittenRoundTable();
        }
        if (this.draft.type === 'verbal') {
          if (words > MAX_WORDS_WRITTEN) {
            return EventBus.$emit('createToast', toast);
          }
          await this.handleCreateVerbalRoundTable();
        }
      },
      handleCreateWrittenRoundTable: async function() {
        if (this.courses.length === 0) {
          EventBus.$emit('createToast', { type: "Warning", message: "Please select at least one course to create a RoundTable", time: 5000 });
          this.$refs.courseMenu.createMenu(this.$refs.courseMenu.getMenuContent);
          return;
        }
        if (this.title.length > 99 || this.title.length < 4 || this.title === '') {
          EventBus.$emit('createToast', { type: 'Error', message: 'Title must have a minimum of 4 characters and a maximum of 99', time: 5000});
          return;
        }
        this.isCreating = true;
        await Axios.put(`/api/drafts/${this.id}`, { courses: this.courses });
        const roundtable = { id: "", premadeId: "", peer_assessment_questions: [] };

        try {
          const { sequence_id } = await this.handleCreateSequence();
        
          for (const c of this.courses) {    
            const payload = {
              course_id: c.id,
              title: this.title,
              prompt: this.written.prompt,
              user_created: true,
              is_generated_by: 'from_genie',
              sequence_id: sequence_id,
              draft_id: this.draft.id,
            };
            const { data } = await RoundtableService.createRT(payload);
            roundtable.id = data.id;
            roundtable.peer_assessment_questions = data.peer_assessment_questions;

            if (this.isToAddToPortfolio === true) {
              const premadeId = await this.handleAddToPortfolio(data.id, this.draft.type);
              roundtable.premadeId = premadeId;
            }
            const courseDetail = await CourseService.courseDetails(c.id);
            const criteria = this.handleGetCriteriaPoints(courseDetail, 'written');
            await this.handleUpdateWrittenRoundTable(data.id, roundtable.premadeId, criteria, roundtable.peer_assessment_questions);
          }

          EventBus.$emit('createToast', { type: 'Success', message: 'Written RoundTable was created successfuly!', time: 5000 });
          
          this.isCreating = false;
          this.$router.push({ name: 'roundtable.index', params: { courseID: this.courses[0].id, roundtableID: roundtable.id }, query: { newRT: true }});

        } catch (error) {
          console.error(error);
          EventBus.$emit('createToast', { type: 'Error', message: 'Something failded creating roundtable! Please try again!', time: 5000 });
        }
      },
      handleCreateVerbalRoundTable: async function() {
        if (this.courses.length === 0) {
          EventBus.$emit('createToast', { type: "Error", message: "Please select at least one course to create a RoundTable", time: 5000 });
          this.$refs.courseMenu.createMenu(this.$refs.courseMenu.getMenuContent);
          return;
        }
        if (this.title.length > 99 || this.title.length < 4 || this.title === '') {
          EventBus.$emit('createToast', { type: 'Error', message: 'Title must have a minimum of 4 characters and a maximum of 99', time: 5000});
          return;
        }
        this.isCreating = true;
        await Axios.put(`/api/drafts/${this.id}`, { courses: this.courses });
        const roundtable = { id: "", premadeId: "" };
        try {
          const { sequence_id } = await this.handleCreateSequence();
          for (const c of this.courses) {
            const draft_id = this.draft.id;
            const data = await LiveDiscussionService.createLiveDiscussion(c.id, this.title, null, this.$route.query.premade_id, 'from_genie', sequence_id, draft_id);
            roundtable.id = data.id;
            this.$store.dispatch('addLiveDiscussionToCourseState', data);
            if (this.isToAddToPortfolio === true) {
              const premadeId = await this.handleAddToPortfolio(data.id, this.draft.type);
              roundtable.premadeId = premadeId;
            }
            const courseDetail = await CourseService.courseDetails(c.id);
            const criteria = this.handleGetCriteriaPoints(courseDetail, 'verbal');
            await this.handleUpdateVerbalRoundtable(data.id, roundtable.premadeId, criteria);
          }

          EventBus.$emit('createToast', { type: 'Success', message: 'Verbal RoundTable was created successfuly!', time: 5000 });
          this.$router.push({ name: 'live-discussion.index', params: { courseID: this.courses[0].id, liveDiscussionID: roundtable.id }, query: { newRT: true }});
          await this.$store.dispatch('enterLiveDiscussion', {
            liveDiscussionID: roundtable.id,
            courseID: this.courses[0].id,
          });
          this.$emit('close');

        } catch (error) {
          console.error(error);
          this.handleCloseDialog();
          EventBus.$emit('createToast', { type: 'Error', message: 'Something happened creating Verbal Discussion! Please try again', time: 5000 });

        }
      },
      handleGetTimezoneString(date) {
        const d = new Date();
        const dtf = Intl.DateTimeFormat('en-US', { timeZoneName: 'long' });
        const result = dtf.formatToParts(d).find((part) => part.type == 'timeZoneName').value;
        return date.toString().split('(')[0] + `(${result})`;
      },
      handleGetCriteriaPoints: function (course, type) {
        const course_points = filter(
          course.points_settings.peer_rewards, (reward) => {
            const { tag } = reward;
            const prefix = type === 'written' ? 'rt' : 'ld';
            return (tag.substring(0, 2) === prefix || tag.substring(0, 3) === 'all');
          }
        );
        return uniqBy([...course_points], 'tag').filter((point) => point);
      },
      handleUpdateWrittenRoundTable: async function (writtenId, premadeId, criteria, peer_assessment_questions) {
        const settings = new DefaultWrittenSettings();
        const timezone_end_date = settings.end_date ? new Date(settings.end_date) : new Date();
        const original_timezone_end_date = this.handleGetTimezoneString(timezone_end_date);

        const htmlString = this.written.prompt;

        const updatedPeerQuestions = peer_assessment_questions.map(question => ({
          ...question,
          is_active: false,
        }));

        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, 'text/html');

        const ulElement = doc.getElementById('peer-questions');

        if (ulElement) {
          const liElements = ulElement.querySelectorAll('li');
          liElements.forEach(li => {
            const text = li.textContent.trim();
            if (text) {
              updatedPeerQuestions.push({ question: text, is_active: true, is_custom: true });
            }
          });
        }

        try {
          const payload = {
            id: writtenId,
            title: this.title.replace(/(\r\n|\n|\r)/gm, ''),
            prompt: this.written.prompt,
            require_submission: settings.require_submission,
            enable_annonymous: settings.enable_annonymous,
            hard_close: settings.hard_close,
            is_ended: settings.is_ended,
            end_date: settings.close_date_enable === true ? settings.end_date : null,
            original_timezone_end_date: original_timezone_end_date,
            points_settings: criteria ? criteria : [],
            peer_assessment_questions: updatedPeerQuestions,
            enable_grading: settings.enable_grading,
            point_cap: settings.point_cap,
            is_email_notifications: settings.is_email_notifications,
            is_genie_feedback_enable: settings.is_genie_feedback_enable,
            meta: premadeId ? { premade_id: premadeId } : null,
            created_universe_premade: premadeId ? premadeId : null,
          };
          await this.$store.dispatch('savingRTDetails', payload);
          return;
        } catch (error) {
          const toast = { type: 'Error', message: 'Something went wrong creating RoundTable, please try again.', time: 5000 };
          EventBus.$emit('createToast', toast);
        }
      },
      handleUpdateVerbalRoundtable: async function(verbalId, premadeId, criteria) {
        const settings =  new DefaultVerbalSettings();
        try {
          const payload = {
            id: verbalId,
            instructions: this.verbal.instructions,
            toggleable_guiding_questions: this.verbal.questions,
            toggleable_resource_questions: this.verbal.resources,
            points_settings: criteria ? criteria : [],
            point_cap: null,
            audio_discussion_is_enabled: settings.audio_discussion_is_enabled,
            auto_turn: settings.auto_turn,
            language: settings.language,
            meta: null,
            created_universe_premade: null,
          };
          await this.$store.dispatch('saveLiveDiscussionSettings', payload);
        } catch (error) {
          console.error(error);
          throw error;
        }
      },
      handleAddToPortfolio: async function (roundtableId, type) {
        const payload = { is_published: true, accessibility: 'Public', published_at: Date.now() };
        const serviceMap = {
          written: RoundtableService.addToUniverse,
          verbal: LiveDiscussionService.addLiveDiscussionToUniverse,
        };
        try {
          if (!serviceMap[type]) {
            throw new Error(`This type not exist: '${type}'`);
          }
          const { data } = await serviceMap[type](roundtableId, payload);
          return data;

        } catch (error) {
          console.error(error);
          EventBus.$emit('createToast', { type: 'Error', message: error.message || 'Something happened addin roundtable to your portfolio...', time: 5000 });
          return null;
        }
      },
      handleGenerateFollowUpPrompt: async function() {
        try {
          if (this.draft.type === 'written') {
            this.written.prompt = GeneratingTemplate;
          }
          if (this.draft.type === 'verbal') {
            this.verbal.instructions = GeneratingTemplateVerbal;

            const messages = [
              "Creating a lesson plan for your class discussion, this should take about 15 seconds!",
              "Sifting through the internet so you don't have to…",
              "Tailoring the discussion prompt to the grade level…",
              "Finding the perfect balance of challenge and curiosity…",
              "Defining learning goals…",
              "Designing higher order questions to spark curiosity and critical thinking…",
              "Generating peer feedback questions..."
            ];
            
            this.intervalID = setInterval(() => {
              const randomIndex = Math.floor(Math.random() * messages.length);
              const newTemplate = GeneratingTemplateVerbal.replace(
                /<span style="font-size: 16px" class="message">.*?<\/span>/,
                `<span style="font-size: 16px" class="message">${messages[randomIndex]}</span>`
              );
              this.verbal.instructions = newTemplate;
            }, 2500);
          }

          const response = await Axios.get(`/api/sequences/v1/generate/follow/up/${this.followUpFromRoundtable.type}/${this.followUpFromRoundtable.id}/${this.draft.type}`);

          if (this.draft.type === 'verbal') {
            clearInterval(this.intervalID);
          }
          
          
          this.title = response.data.title;
          if (this.draft.type === 'written') {
            this.written.prompt = response.data.template;
          }
          if (this.draft.type === 'verbal') {
            this.verbal.instructions = response.data.summary || "";
            this.verbal.questions = response.data.questions || [];
            this.verbal.resources = response.data.resources || [];
          }
          const payload = { 
            is_generated: true, 
          };
          await Axios.put(`/api/drafts/${this.id}`, payload);
        } catch (error) {
          console.error(error);
        }
      },
      handleCreateSequence: async function() {
        try {
          if (this.draft.is_follow_up) {
            const is_roundtable_in_sequence = this.followUpFromRoundtable.sequence_id === null ? false : true;
            let users_invited = [];
            let created_sequence_id = null;
            if (!is_roundtable_in_sequence) {
              const payload = {
                title: this.followUpFromRoundtable.title + ' - Sequence',
                course_id: this.followUpFromRoundtable.course_id,
                author_id: this.getProfile.id,
                previous_roundtable_id: this.followUpFromRoundtable.id,
                previous_roundtable_type: this.followUpFromRoundtable.type,
              };
              const { data } = await Axios.post('/api/sequences', payload);
              created_sequence_id = data.data.id;
            }
            if (this.followUpFromRoundtable.type === 'written' || this.followUpFromRoundtable.type === 'roundtable') {
              const co_teachers = this.getCourseDetail.users.filter((user) => user.subscription.role === 'co-teacher');
              if (co_teachers && co_teachers.length > 0) {
                const sub_ids = this.followUpFromRoundtable.submissions.map((s) => s.user.id);
                co_teachers.forEach((c, index) => {
                  if (sub_ids.includes(c.id)) {
                    sub_ids.splice(index, 1);
                  }
                });
                users_invited = sub_ids;
              } else {
                this.followUpFromRoundtable.submissions.filter((s) => s.user && s.user.id).map((s) => users_invited.push(s.user.id));
              }
            }
            if (this.followUpFromRoundtable.type === 'verbal' || this.followUpFromRoundtable.type === 'live_discussion') {
              if (this.followUpFromRoundtable.co_teachers && this.followUpFromRoundtable.co_teachers.length) {
                const participation_ids = this.followUpFromRoundtable.participations.map((p) => p.user.id);
                this.followUpFromRoundtable.co_teachers.forEach((c, index) => {
                  if (participation_ids.includes(c.id)) {
                    participation_ids.splice(index, 1);
                  }
                });
                users_invited = participation_ids;
              } else {
                this.followUpFromRoundtable.participations.filter((p) => p.user && p.user.id).map((p) => users_invited.push(p.user.id));
              }
            }
            return { sequence_id: created_sequence_id ? created_sequence_id : this.followUpFromRoundtable.sequence_id, users_invited };
          }
          return { sequence_id: null, users_invited: null };
          
        } catch (error) {
          console.error(error);
        }
      }
    },
    mounted: async function() {
      const { data } = await this.handleGetDraft();
      this.initialActivityPasses = this.getProfile.activity_passes;

      this.draft = data;
      this.title = data.title;
      this.courses = data.courses;
      this.followUpFromId = data.follow_up_from_id;

      if (this.isFollowUp === true) {
        if (this.draft.follow_up_from_type === 'written') {
          const roundtable = await RoundtableService.loadRoundtable(this.followUpFromId);
          this.followUpFromRoundtable = roundtable;
        }

        if(this.draft.follow_up_from_type === 'verbal') {
          const roundtable = await LiveDiscussionService.loadLiveDiscussion(this.followUpFromId);
          this.followUpFromRoundtable = roundtable.data;
          
        }
        if (this.draft.is_generated === false) {
          await this.handleGenerateFollowUpPrompt();
          
        } else {
          if (this.draft.type === 'written') {
            this.written.prompt = this.draft.prompt;
          }
          if (this.draft.type === 'verbal') {
            this.verbal.instructions = data.instructions;
            this.verbal.questions = data.toggleable_guiding_questions || [];
            this.verbal.resources = data.toggleable_resource_questions || [];
          }
        }
      } else {
        this.input = this.$route.query.input !== '' ? this.$route.query.input : this.draft.file;

        if (data.is_follow_up === true) {
          if (data.follow_up_from_type === 'written') {
            const roundtable = await RoundtableService.loadRoundtable(this.followUpFromId);
            this.followUpFromRoundtable = roundtable;
          }

          if(data.follow_up_from_type === 'verbal') {
            const roundtable = await LiveDiscussionService.loadLiveDiscussion(this.followUpFromId);
            this.followUpFromRoundtable = roundtable.data;
          }
        }

        if (data.type === 'written') {
          if (this.input) {
            await Promise.all([this.handleGenerateWrittenPrompt(), this.handleGenerateOption()]);
          } else {
            this.written.prompt = data.prompt;
          }
        }
        if (data.type === 'verbal') {
          if (this.input) {
            await Promise.all([this.handleGenerateVerbalPrompt(), this.handleGenerateOption()]);
          } else {
            this.verbal.instructions = data.instructions;
            this.verbal.questions = data.toggleable_guiding_questions || [];
            this.verbal.resources = data.toggleable_resource_questions || [];
          }
        }
      }

      if (this.draft.type === 'written') {
        this.$nextTick(() => {
          const editorInstance = this.$refs.editorWrittenPrompt.editor;
          if (editorInstance) {
            editorInstance.options.set('disabled', false);
          }
        });
      }


      EventBus.$on("handleSelection", (data) => {
        this.written.selection = data.selected;
        this.revise.mode = data.mode;
      });

      EventBus.$on('handleRevisePrompt', () => {
        this.$refs.genieRevise.focus();
      });
    },
    beforeDestroy() {
      EventBus.$off('handleSelection');
      EventBus.$off('handleRevisePrompt');
    },
  };
</script>
<style scoped>

  .progress {
    animation: progress 1s infinite linear;
  }

  .left-right {
    transform-origin: 0% 50%;
  }
  @keyframes progress {
    0% {
      transform:  translateX(0) scaleX(0);
    }
    40% {
      transform:  translateX(0) scaleX(0.4);
    }
    100% {
      transform:  translateX(100%) scaleX(0.5);
    }
  }
  .loader,
  .loader:after {
    border-radius: 50%;
    width: 16px;
    height: 16px;
    margin-top: 1px;
  }
  .loader {
    border-top: 3px solid rgba(255, 255, 255, 0.2);
    border-right: 3px solid rgba(255, 255, 255, 0.2);
    border-bottom: 3px solid rgba(255, 255, 255, 0.2);
    border-left: 3px solid #ffffff;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-animation: load8 1.1s infinite linear;
    animation: load8 1.1s infinite linear;
  }
  @-webkit-keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  .genie-background {
    background: rgb(12, 112, 168);
    background: linear-gradient(
      47deg,
      rgba(12, 112, 168, 0.2) 0%,
      rgba(255, 35, 165, 0.3) 100%
    );
  }
</style>


// WEBPACK FOOTER //
// Index.vue?1a379cb0